import { NgModule } from '@angular/core';
import {
    PreloadAllModules,
    provideRouter,
    RouterModule,
    Routes,
    withInMemoryScrolling,
    withPreloading,
} from '@angular/router';

import {
    CallbackComponent,
    UnauthorizedComponent,
} from '@privatelib/ngx18-authz-dev';

import { Error500Component, PageNotFoundComponent } from './components/';
import { LayoutComponent } from './layout/layout.component';

import { AuthGuard } from './services/guards/auth.guard';
import { noAuthGuard } from './services/guards/no-auth.guard';

import { initialDataResolver } from './app.resolvers';
import { ROUTE_CONSTANTS } from './util/route.constants';
import { AeroCloudAuthComponent } from './components/auth/aero-cloud-auth/aero-cloud-auth/aero-cloud-auth.component';
import { InvalidAgentComponent } from './components/error/invalid-agent/invalid-agent.component';
import { userAgentGuard } from './services/guards/user-agent-guard/user-agent-guard.guard';

const routes: Routes = [
    {
        path: ROUTE_CONSTANTS.AERO_CLOUD_AUTH,
        component: AeroCloudAuthComponent,
        canActivate: [userAgentGuard], 
    },
    { 
        path: 'error', pathMatch: 'full', 
        component: Error500Component,
        canActivate: [userAgentGuard, noAuthGuard], 
    },
    {
        path: '404-not-found',
        pathMatch: 'full',
        component: PageNotFoundComponent,
        canActivate: [userAgentGuard, noAuthGuard],
    },
    { 
        path: ROUTE_CONSTANTS.INVALID_AGENT, 
        component: InvalidAgentComponent
    },
    { path: '', pathMatch: 'full', redirectTo: ROUTE_CONSTANTS.LANDING_PAGE },

    // for unauthorized users, without any sidebar
    {
        path: '',
        canActivate: [userAgentGuard, noAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: ROUTE_CONSTANTS.LOGIN,
                loadChildren: () =>
                    import('app/components/auth/sign-in/sign-in.routes'),
            },
            {
                path: ROUTE_CONSTANTS.FORGOT_PASSWORD,
                loadChildren: () =>
                    import(
                        'app/components/auth/forgot-password/forgot-password.routes'
                    ),
            },
            {
                path: ROUTE_CONSTANTS.SIGNUP,
                loadChildren: () =>
                    import('app/components/auth/signup/signup.routes'),
            },
            {
                path: ROUTE_CONSTANTS.PRICING,
                loadChildren: () =>
                    import(
                        'app/components/modules/subscription-pricing/subscription.routes'
                    ),
            },
            // {
            //     path: ROUTE_CONSTANTS.SUBSCRIBE,
            //     loadChildren: () =>
            //         import(
            //             'app/components/modules/user-subscription/user-subscription.routes'
            //         ),
            // },
            {
                path: ROUTE_CONSTANTS.RESET_PASSWORD,
                loadChildren: () =>
                    import(
                        'app/components/auth/reset-password/reset-password.routes'
                    ),
            },
            {
                path: ROUTE_CONSTANTS.PAYMENT_SUCCESS,
                loadChildren: () =>
                    import(
                        'app/components/modules/payment-success/payment-success.routes'
                    ),
            }
        ],
    },

    // for authorized users, without any sidebar
    {
        path: '',
        canActivate: [userAgentGuard, AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            /* {
                path: ROUTE_CONSTANTS.LOGOUT,
                loadChildren: () =>
                    import('app/components/auth/sign-out/sign-out.routes'),
            }, */
        ],
    },
    // for authorized users, with sidebar
    {
        path: '',
        canActivate: [userAgentGuard, AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: ROUTE_CONSTANTS.LANDING_PAGE,
                loadChildren: () =>
                    import(
                        'app/components/modules/landing-page/landing-page.routes'
                    ),
            },
            {
                path: ROUTE_CONSTANTS.CONSULTATION,
                loadChildren: () =>
                    import(
                        'app/components/modules/consultation/consultation.routes'
                    ),
            },
            /* {
                path: ROUTE_CONSTANTS.PAST_SESSION,
                loadChildren: () =>
                    import(
                        'app/components/modules/past-session/past-session.routes'
                    ),
            }, */
            {
                path: ROUTE_CONSTANTS.PREFERENCES,
                loadChildren: () =>
                    import(
                        'app/components/modules/preferences/preferences.routes'
                    ),
            },
            {
                path: ROUTE_CONSTANTS.HELP_SECTION,
                loadChildren: () =>
                    import(
                        'app/components/modules/help-section/help-section.routes'
                    ),
            },
            /* {
                path: ROUTE_CONSTANTS.SETTINGS,
                loadChildren: () =>
                    import('app/components/modules/settings/settings.routes'),
            }, */
            {
                path: ROUTE_CONSTANTS.MANAGE_TEMPLATES,
                loadChildren: () =>
                    import(
                        'app/components/modules/manage-template/manage-templates.routes'
                    ),

            },
            { path: 'auth/callback', component: CallbackComponent },
            { path: 'auth/unauthorized', component: UnauthorizedComponent },
            { path: 'error', redirectTo: ROUTE_CONSTANTS.LANDING_PAGE },
            { path: '**', redirectTo: ROUTE_CONSTANTS.LANDING_PAGE },
        ],
    },
    { path: '**', redirectTo: ROUTE_CONSTANTS.SETTINGS },
];
@NgModule({
    imports: [RouterModule.forRoot(routes, { enableTracing: false })],
    providers: [
        provideRouter(
            routes,
            withPreloading(PreloadAllModules),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
        ),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
